import React from 'react'
import "./Spinner.css"

const Spinner = () => {
  return (
    <div className='flex justify-center items-center h-vh w-vw'>
        <div className='spinner '>
        </div>
    </div>
  )
}

export default Spinner